(function () {
    'use strict';

    angular.module('itxApp.cmsPage')
        .service('ChangeCategoryService', ChangeCategoryService);

    ChangeCategoryService.$inject = [
        'ItxApiSvc',
        '$rootScope',
        'HomeAnalitics',
        'itxCmsUtilsSvc'
    ];

    function ChangeCategoryService(
        ItxApiSvc,
        $rootScope,
        HomeAnalitics,
        itxCmsUtilsSvc
    ) {
        var _this = this;

        return {
            go: _go
        };

        function _go(param) {
            let categoryFound = false;
            let id = param.categoryId;
            let isCatalogPage = inditex.iPage === "ItxCategoryPage" || inditex.iPage === "ItxProductPage";

            if (!id) {
                return categoryFound;
            }

            let redirectToDuttistatic = false;
            let redirectToApollo = false;
            let hasDuttistatic = isCatalogPage && inditex.iCategoryJSON && inditex.iCategoryJSON.type === '14';
            let hasApollo = isCatalogPage && inditex.iCategoryJSON && inditex.iCategoryJSON.type === '22';

            if (isCatalogPage) {
                ItxApiSvc.getCategoryTree().then(function (res) {
                    for (let index = 0; index < res.categories.length; index++) {
                        if (!categoryFound) {
                            categoryFound = searchCategory(res.categories[index], id);
                        }
                    }
                    
                    console.log('CATEGORIA SELECCIONADA ID ', categoryFound);

                    if (categoryFound && categoryFound.type === '14') {
                        redirectToDuttistatic = true;
                    } else if (categoryFound && categoryFound.type === '22') {
                        redirectToApollo = true;
                    }

                    if (hasDuttistatic && redirectToDuttistatic) {
                        $rootScope.$broadcast('categoryCtrl:updateCategory', {
                            id: id
                        });
                    } else if (hasApollo && redirectToApollo) {
                        param.typeEvent = 'category';
                        const options = {
                            bubbles: true,
                            composed: true,
                            detail: {
                                extra: param
                            }
                        };
                        document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
                        //TODO analitica navegacion entre apollo #:41-46
                    } else {
                        itxCmsUtilsSvc.doClick(id);
                    }
                });

            } else {
                itxCmsUtilsSvc.doClick(id);
            }

            HomeAnalitics.sendCategoryPath(id, null, null, null);
            $('html').removeClass('no-scroll');
        }

        function _getNamePiece(name) {
            var res = null;
            var resError = 'ERROR_ANALITICA_CMS';
            var namesAllowed = [
                'collection',
                'image',
                'discover',
                'slider',
                'menu_category'
            ];
            if (!name) {
                console.error('HOME CMS ANALITICA - ', resError);
                return resError;
            }
            _.each(namesAllowed, function (allowedName) {
                if (_.includes(allowedName, name.toLowerCase())) {
                    res = allowedName;
                }
            });
            if (res) {
                return res;
            } else {
                console.error('HOME CMS ANALITICA - ', resError + '_NAME_IS_NOT_ALLOWED');
                return resError + '_NAME_IS_NOT_ALLOWED';
            }
        }

        function searchCategory(cat, id) {
            if (cat.id == id){
                return cat;
            } else if (cat.subcategories.length > 0) {
                for (let i = 0; i < cat.subcategories.length; i++) {
                    let subcat = searchCategory(cat.subcategories[i], id);
                    if(subcat){
                        return subcat;
                    }
                }
            }
        }
    }

})();